import React, { useEffect, useRef } from 'react';
import { defineCustomElements } from '@om-design-system/web-components/loader';

const OmAlert = React.forwardRef(({
  alertType = 'info',
  icon,
  alertTitle,
  message,
  showActions = false,
  layout = 'vertical',
  children,
  className,
  style,
  ...props
}, ref) => {
  const elementRef = useRef(null);

  useEffect(() => {
    defineCustomElements();
  }, []);

  return (
    <omk-alert
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      alert-type={alertType}
      icon={icon}
      alert-title={alertTitle}
      message={message}
      show-actions={showActions}
      layout={layout}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </omk-alert>
  );
});

OmAlert.displayName = 'OmAlert';

export default OmAlert;
